import { defineMessages } from 'react-intl';

export const referenceRateValuesMessages = defineMessages({
    values: {
        id: 'reference-rate-values',
        defaultMessage: 'Values',
    },
    value: {
        id: 'reference-rate-value',
        defaultMessage: 'Value',
    },
    valueHistory: {
        id: 'reference-rate-value-history',
        defaultMessage: 'Value history',
    },
    amount: {
        id: 'reference-rate-value-amount',
        defaultMessage: 'Amount',
    },
    sourceNote: {
        id: 'reference-rate-value-source-note',
        defaultMessage: 'Source note',
    },
    sourceNotePlaceholder: {
        id: 'reference-rate-value-source-note-placeholder',
        defaultMessage: 'e.g. СГ 2026/12, в сила от 01.01.2026',
    },
    version: {
        id: 'reference-rate-value-version',
        defaultMessage: 'Version',
    },
    openEnded: {
        id: 'reference-rate-value-open-ended',
        defaultMessage: 'Open ended',
    },
    contiguityHint: {
        id: 'reference-rate-value-contiguity-hint',
        defaultMessage:
            'A new value must start where the previous one ends - the series cannot have gaps, and the newest value always stays open ended.',
    },
    cannotEditNotScheduled: {
        id: 'reference-rate-value-cannot-edit-not-scheduled',
        defaultMessage: 'Only a value that has not started yet can be edited.',
    },
    cannotDeleteNotScheduled: {
        id: 'reference-rate-value-cannot-delete-not-scheduled',
        defaultMessage: 'Only the last value, and only while it has not started yet, can be deleted.',
    },
    addReferenceRateValueSubtitle: {
        id: 'add-reference-rate-value-subtitle',
        defaultMessage: 'Add a value to the rate history',
    },
    createReferenceRateValueSuccess: {
        id: 'create-reference-rate-value-success',
        defaultMessage: 'Value added',
    },
    createReferenceRateValueSuccessDescription: {
        id: 'create-reference-rate-value-success-description',
        defaultMessage: 'The reference rate value has been successfully added.',
    },
    editReferenceRateValueSubtitle: {
        id: 'edit-reference-rate-value-subtitle',
        defaultMessage: 'Edit a scheduled reference rate value',
    },
    updateReferenceRateValueSuccess: {
        id: 'update-reference-rate-value-success',
        defaultMessage: 'Value updated',
    },
    updateReferenceRateValueSuccessDescription: {
        id: 'update-reference-rate-value-success-description',
        defaultMessage: 'The reference rate value has been successfully updated.',
    },
    deleteReferenceRateValue: {
        id: 'delete-reference-rate-value',
        defaultMessage: 'Delete value',
    },
    deleteReferenceRateValueSubtitle: {
        id: 'delete-reference-rate-value-subtitle',
        defaultMessage: 'Permanently delete version {entity}',
    },
    confirmDeleteReferenceRateValue: {
        id: 'confirm-delete-reference-rate-value',
        defaultMessage: 'Are you sure you want to delete this reference rate value? This action cannot be undone.',
    },
    deleteReferenceRateValueSuccess: {
        id: 'delete-reference-rate-value-success',
        defaultMessage: 'Value deleted',
    },
    deleteReferenceRateValueSuccessDescription: {
        id: 'delete-reference-rate-value-success-description',
        defaultMessage: 'The reference rate value has been successfully deleted.',
    },
    // Server error codes (see the indexed pricing API contract).
    referenceRateValueGapError: {
        id: 'custom-error:reference_rate_value_gap',
        defaultMessage: 'This would leave a gap in the value history. A value must start where the previous one ends!',
    },
    seriesMustBeOpenEndedError: {
        id: 'custom-error:reference_rate_series_must_be_open_ended',
        defaultMessage: 'The newest value in the history cannot have an end date!',
    },
    editCurrentOrPastValueError: {
        id: 'custom-error:edit_current_or_past_reference_rate_value',
        defaultMessage:
            'Only a value that has not started yet can be edited or deleted. Add a new value with a future start date instead!',
    },
    changeReferenceRateValueRateError: {
        id: 'custom-error:change_reference_rate_value_rate',
        defaultMessage: 'A value cannot be moved to a different reference rate!',
    },
    uncoversPricingPolicyError: {
        id: 'custom-error:update_reference_rate_value_uncovers_pricing_policy',
        defaultMessage: 'This change would leave an indexed pricing policy without a rate value covering it!',
    },
    deleteNotLastValueError: {
        id: 'custom-error:delete_not_last_reference_rate_value',
        defaultMessage: 'Only the last value in the history can be deleted!',
    },
    deleteValueWithChargesError: {
        id: 'custom-error:delete_reference_rate_value_with_charges',
        defaultMessage: 'This value has already been used for billing and cannot be deleted!',
    },
    deleteLastValueWithPricingPoliciesError: {
        id: 'custom-error:delete_last_reference_rate_value_with_pricing_policies',
        defaultMessage:
            'This is the only value of a rate that pricing policies are indexed to, so it cannot be deleted!',
    },
});
